$(document).ready(function () {
	if ($(".runet-award").length > 0) {
		window.addEventListener("scroll", (e) => {
			const $scrollBlock = $(".js-scroll");
			const $scrollMobile = $(".js-scroll-mobile");
			const $scrollImage = $(".js-scroll-image");
			const $scrollBlockTop = $scrollBlock.offset().top;
			const $scrollMobileTop = $scrollMobile.offset().top;
			const imgHeight = $(
				".runet-award-block8__content-mobile-mask-inner img"
			).height();
			const deskImgHeight = $(
				".runet-award-block8__content-desktop-inner img"
			).height();
			const isTablet =
				$(window).width() <= 1024 && $(window).width() >= 768;

			const sizeValue = isTablet
				? imgHeight / deskImgHeight
				: 4240 / (3921 - 40);

			const topValue = isTablet
				? $scrollMobileTop -
				  $scrollBlockTop +
				  ($(window).width() - 768) / 2
				: $scrollMobileTop - $scrollBlockTop;

			if ($scrollMobileTop >= $scrollBlockTop) {
				$scrollImage
					.find("img")
					.css("top", `-${topValue * sizeValue}px`);
			}
		});
	}
});
